var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import generate_jwt from "./jwt/jwt";
import AppConfig from "../app-config";
const jsonSafeGet = (jsonString, defaultData = {}) => {
    let output = defaultData;
    try {
        output = JSON.parse(jsonString);
    }
    catch (e) {
        // do nothing.
    }
    return output;
};
export const isDeviceMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");
};
export const getDataFromStorage = () => {
    // return {
    //     tgt_ticket: "80efe93bb492434af9e74efe7057a72a627bda66f493706bff7cb5c54a8872bf",
    //     tgt_timestamp: "1675633807",
    //     userInfo: {id: 63826092}
    // }
    // Feras User
    //
    // return {
    //     tgt_ticket: "ad839c8acbfc081f311e2f1bc265c0a5f11ba6e9646229bd2ff51dd4dd88370f",
    //     tgt_timestamp: "1677572722",
    //     userInfo: {
    //         id: 50986704,
    //         full_name: "Feras",
    //         profile_picture: "#noImage"
    //     },
    //     source: 'desktop',
    //     country: 'jo'
    // }
    //
    //maen user
    // return {
    //     tgt_ticket: "dcc6954ce584bd5b7410668c53e05b34d85bd9fec7668526c752adaf79a7223d",
    //     tgt_timestamp: "1677342152",
    //     userInfo: {
    //         id: 65142094,
    //         full_name: "Maen",
    //         profile_picture: "#noImage"
    //     },
    //     source: 'desktop',
    //     country: 'jo'
    // }
    //opensooq user
    //     return {
    //         tgt_ticket: "035ba0075d7ec46d7612d9d7589b294e03d3fb538f491b1658ebcf561cd9602e",
    //         tgt_timestamp: "1677147287",
    //         userInfo: {
    //             id: 14442064
    //         },
    //         source: 'desktop',
    //         country: 'jo'
    //     }
    return {
        tgt_timestamp: AppConfig.getConfig().authenticationData.tgtTimestamp,
        tgt_ticket: AppConfig.getConfig().authenticationData.tgtTicket,
        userInfo: AppConfig.getConfig().authenticationData.userInfo,
        source: AppConfig.getConfig().authenticationData.source,
        audience: AppConfig.getConfig().authenticationData.audience,
        country: AppConfig.getConfig().authenticationData.country
    };
};
export const generateToken = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { tgt_ticket, tgt_timestamp, userInfo } = getDataFromStorage();
    const id = (_a = userInfo.id) === null || _a === void 0 ? void 0 : _a.toString();
    if (!tgt_ticket)
        return null;
    // if (!id || id.startsWith("_")) throw new Error("ID isn't valid.")
    return generate_jwt(Number(tgt_timestamp), tgt_ticket, id);
});
